import React, { useState } from 'react';
import { ArrowLeft } from 'lucide-react';

interface RegistrationPageProps {
  onBack: () => void;
  onSelectTerm: (term: string) => void;
}

const RegistrationPage: React.FC<RegistrationPageProps> = ({ onBack, onSelectTerm }) => {
  const [selectedTerm, setSelectedTerm] = useState('EC SEPTIEMBRE 2026 (View only)');

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Header */}
      <header className="bg-white shadow-sm">
        <div className="px-4 py-3">
          <div className="flex items-center">
            {/* Logo */}
            <img 
              src="/logo.png" 
              alt="TecMilenio Logo" 
              className="h-12 w-auto"
              style={{ filter: 'brightness(0) saturate(100%) invert(27%) sepia(51%) saturate(2878%) hue-rotate(120deg) brightness(104%) contrast(97%)' }}
            />
          </div>
        </div>
      </header>

      {/* Green Navigation Bar */}
      <div className="bg-green-500 text-white py-2">
        <div className="max-w-7xl mx-auto px-4">
          {/* Empty green bar for visual consistency */}
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 py-6">
        <div className="flex justify-between items-start">
          {/* Left Content */}
          <div className="flex-1">
            {/* Back Button */}
            <button 
              onClick={onBack}
              className="flex items-center text-blue-600 hover:text-blue-800 mb-4"
            >
              <ArrowLeft size={20} className="mr-1" />
            </button>

            {/* Breadcrumb */}
            <nav className="text-sm text-gray-600 mb-6">
              <span>Home</span>
              <span className="mx-2">&gt;</span>
              <span>Alumnos</span>
              <span className="mx-2">&gt;</span>
              <span>Registration</span>
              <span className="mx-2">&gt;</span>
              <span className="font-semibold text-gray-800">Seleccionar Periodo</span>
            </nav>

            {/* Page Title */}
            <h1 className="text-2xl font-bold text-gray-800 mb-8">Registration Term</h1>

            {/* Term Selection */}
            <div className="bg-white rounded-lg shadow p-6">
              <div className="mb-6">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Select a Term:
                </label>
                <select 
                  value={selectedTerm}
                  onChange={(e) => setSelectedTerm(e.target.value)}
                  className="border border-gray-300 rounded px-3 py-2 bg-white text-gray-800 w-full"
                >
                  <option value="EC SEPTIEMBRE 2026 (View only)">EC SEPTIEMBRE 2026 (View only)</option>
                  <option value="2026 EC Jul-Sep (View only)">2026 EC Jul-Sep (View only)</option>
                  <option value="EC AGOSTO 2026 (View only)">EC AGOSTO 2026 (View only)</option>
                  <option value="EC JULIO 2026 (View only)">EC JULIO 2026 (View only)</option>
                  <option value="EC JUNIO 2026 (View only)">EC JUNIO 2026 (View only)</option>
                  <option value="EC MAYO 2026 (View only)">EC MAYO 2026 (View only)</option>
                  <option value="EC ABRIL 2026 (View only)">EC ABRIL 2026 (View only)</option>
                  <option value="EC MARZO 2026 (View only)">EC MARZO 2026 (View only)</option>
                  <option value="EC ENERO 2026 (View only)">EC ENERO 2026 (View only)</option>
                  <option value="EC DICIEMBRE 2025 (View only)">EC DICIEMBRE 2025 (View only)</option>
                  <option value="EC NOVIEMBRE 2025 (View only)">EC NOVIEMBRE 2025 (View only)</option>
                  <option value="EC OCTUBRE 2025 (View only)">EC OCTUBRE 2025 (View only)</option>
                  <option value="EC SEPTIEMBRE 2025 (View only)">EC SEPTIEMBRE 2025 (View only)</option>
                  <option value="EC AGOSTO 2025 (View only)">EC AGOSTO 2025 (View only)</option>
                  <option value="EC M2 2025 (View only)">EC M2 2025 (View only)</option>
                  <option value="EC JUNIO 2025 (View only)">EC JUNIO 2025 (View only)</option>
                  <option value="2026 EC May-Jul (View only)">2026 EC May-Jul (View only)</option>
                  <option value="2026 EC Abr-Jun (View only)">2026 EC Abr-Jun (View only)</option>
                  <option value="2026 EC Mar-May (View only)">2026 EC Mar-May (View only)</option>
                  <option value="2026 Idiomas Feb - May (View only)">2026 Idiomas Feb - May (View only)</option>
                  <option value="2026 EC Feb-Abr (View only)">2026 EC Feb-Abr (View only)</option>
                  <option value="2026 EC Ene-Mar (View only)">2026 EC Ene-Mar (View only)</option>
                  <option value="2025 EC Dic-Feb (View only)">2025 EC Dic-Feb (View only)</option>
                  <option value="2025 EC Nov-Ene (View only)">2025 EC Nov-Ene (View only)</option>
                  <option value="2025 EC Oct-Ene (View only)">2025 EC Oct-Ene (View only)</option>
                  <option value="2025 EC Sep-Nov (View only)">2025 EC Sep-Nov (View only)</option>
                  <option value="2025 EC Ago-Oct (View only)">2025 EC Ago-Oct (View only)</option>
                  <option value="2025 EC Jul-Sep (View only)">2025 EC Jul-Sep (View only)</option>
                </select>
              </div>

              {/* Submit Button */}
              <button 
                onClick={() => onSelectTerm(selectedTerm)}
                className="bg-gray-600 hover:bg-gray-700 text-white px-6 py-2 rounded font-medium"
              >
                Submit
              </button>
            </div>
          </div>

          {/* Right Sidebar - User Info */}
          <div className="ml-8 text-right text-sm text-gray-600">
            <div className="font-medium">T07182039 Pablo Villarreal Lamberta</div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-white border-t mt-auto">
        <div className="max-w-7xl mx-auto px-4 py-4">
          <div className="flex justify-between items-center text-sm text-gray-600">
            <div>© 2026 Ellucian Company L.P. and its affiliates.</div>
            <div>SITE MAP</div>
          </div>
          <div className="mt-2 text-sm text-gray-600">
            RELEASE: 8.4 [ITSM: 014.2.0]
          </div>
        </div>
        
        {/* Bottom Green Bar */}
        <div className="bg-green-500 py-2">
          <div className="max-w-7xl mx-auto px-4 text-right">
            <span className="text-white text-sm font-medium">SUNGARD HIGHER EDUCATION</span>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default RegistrationPage;